import React from "react";

export const BoutiqueLocation = () => {
  return (
    <div id="location" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', textAlign: 'center', padding: '20px' }}>
      <div>
        <h2>Visit Our Boutique</h2>
        <p>
          We are located at <strong>The Painted Tree</strong> in Lincoln, NE in spot <strong>C26</strong>
        </p>
        <p>
          Come and explore a variety of boutique items in our unique store!
        </p>
        <div style={{ marginTop: '20px' }}>
          <iframe
            title="Painted Tree Lincoln Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3069.5265465194575!2d-96.68077458463363!3d40.75929987932654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8796c7cf1d73e7d5%3A0x5e1f9e62e3e0c35c!2s2960%20Pine%20Lake%20Rd%2C%20Lincoln%2C%20NE%2068516!5e0!3m2!1sen!2sus!4v1697805292711!5m2!1sen!2sus"
            width="600"
            height="450"
            style={{ border: '0', maxWidth: '100%' }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </div>
  );
};
